import '../sunpharma(1)/css/mcq_ans.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Footer from '../components/footer';
import Com_Logo from '../components/company_icon';
import { useNavigate } from 'react-router-dom';


const MCQSheet = () => {

  const navigate = useNavigate();
  const [questionsData, setQuestionsData] = useState([]);

  
// console.log('data',questionsData);

// same api use karva mate get value retype lakhi che
const event = sessionStorage.getItem('event');
const lea_event = sessionStorage.getItem('lea_event');
const user_type = sessionStorage.getItem('user_type');

  useEffect(() => {
    axios
          //http://localhost/PROJECT/REACT/lms/src/api/ans.php
          //./api/ans.php
      .get('./api/ans.php',{
        params: {
          event: event,
          lea_event: lea_event,
          user_type: user_type
        }
      })

      .then((response) => {

        if (Array.isArray(response.data)) {
          setQuestionsData(response.data);
        } else {
          // console.error('Invalid response:', response.data);
        }
      })
      .catch((error) => {
        // console.error('Error fetching MCQs:', error);
      });
  }, []);

  const checkAnswer = (option, questionIndex) => {
    const fullOption = `${option.label}.${option.text}`;
    const correctOption = questionsData[questionIndex]?.correct_option;

    // console.log('Full Option:', fullOption);
    // console.log('Correct Option:', correctOption);

   return fullOption === correctOption;
  };

  const handleCerti = () =>{
    navigate("../certificate")
  }

  return (
    <>
      <Com_Logo />

      <div className="mcq-container">
        <h2 className="heading" style={{ textAlign: 'center' }}>Answer Sheet</h2>

        {questionsData.length > 0 && (
          <>
            {questionsData.map((question, index) => (
              <div className="mcq-card" key={index}>
                <h3 className='qutions_ans'>{`Q${index + 1}. ${question.question}`}</h3>
                <div className="options">
                  {question.options.map((option, i) => {
                    const isCorrect = checkAnswer(option, index);
                    return (
                      <div className="option" key={i} style={{ background: '#f2f4f8', border: '0px' }}>
                        <span className={isCorrect ? 'correct' : ''}>
                          {option.label}. {option.text}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </>
        )}

        {/* certificate */}
         <button className="certi-btn" type="button" onClick={handleCerti}>Certificate
        </button>

      </div>

      <Footer />
    </>
  );
};

export default MCQSheet;
